// Central mutation gate for the Business SKU lapse policy
// (IN_PLACE_ADAPTATION.md "Monetization"): while the ACTIVE business is in
// read_only mode every mutation affordance — post/save/issue/void/
// record-payment/connect/ignore/match — hides or disables through this ONE
// hook, consumed where actions render. Reads, reports and exports stay live.
//
// Outside a BusinessProvider (preview/teaser mode) mutations are allowed —
// the sample-data experience is local-only and never hits the live API.
// The server enforces the policy regardless (403 business_read_only), which
// businessApiCommon maps to a toast as a safety net for anything missed.

import { useBusinessOptional } from '../contexts/BusinessContext';

export interface BusinessMutability {
  /** True when the active business is entitlement-lapsed (read_only). */
  readOnly: boolean;
  /** Convenience inverse — render/enable mutation affordances only when true. */
  canMutate: boolean;
}

export function useBusinessMutability(): BusinessMutability {
  const business = useBusinessOptional();
  const readOnly = business?.readOnly === true;
  return { readOnly, canMutate: !readOnly };
}
